export default __webpack_public_path__ + "static/media/AWConquerorDidot-Light.8c312062.woff";